import React from 'react';
import { Service, Portfolio as PF, Responsive } from '../components';
import { TagWrapper } from '../components/general';
import { entries } from './portfolio';

export const About = (
	<p>
		Vital 38 is a web development and media production firm based in the Silicon Valley.
		<br />
		We work with you to create a digital media solution that is fast, beautiful, and tailored to your every need.
		<br />
		<br />
		On Average, 38% of consumers will stop engaging with a product or website if the content is unattractive.
		<br />
		<br />
		With a focus on unique, modern design, V38 will help small businesses, companies, and individuals stand out and grow with a well-designed and meticulously planned online presence.
		<br />
		<br />
		Don't lose the vital 38%
		<br />
		<br />
		<br />
	</p>
);

export const Services = (
	<span>
		<Service
			title="Managed"
			content="We give the option to manage everything for you, from hosting to domain registration. Gone are the days of worrying about expired credit cards or renewals"
			icon="magic"
		/>
		<Service
			title="Support"
			content="We have options to fit your needs for maintaining support after project completion"
			icon="life-ring"
		/>
		<Service
			title="Platforms"
			content="NodeJS, React, Wordpress, Joomla, Electron, the list goes on. We support a huge variety of frameworks and languages"
			icon="code"
		/>
		<Service
			title="Cloud System"
			content="A custom backend means your project has the flexibility to become whatever you can dream up. Alternatively, we provide a standard, in-house backend stack to build on"
			icon="cogs"
		/>
		<Service
			title="Digital Media"
			content="We'll work with you to create custom digial media - photos and video - and work to rely on stock media as little as possible - or not at all"
			icon="camera-retro"
		/>
		<br />
		<br />
		<br />
	</span>
);

export const Design = (
	<p>
		In modern web development, every website should look great on every device. That's why our designs are always fully responsive for desktop, mobile, and tablet. Your users deserve the best, no matter what device they're using.
		<br />
		<br />
		Whatever your needs are, we're here to help make sure you end up with the best product possible! We believe that good design, quality code, and a well-developed idea are essential to any product's success, no matter how big or small.
		<br />
		<br />
		<br />
	</p>
);

export const Portfolio = (<span><PF items={entries} /><br /><br /></span>);

export const Home = (
	<TagWrapper>
		<Responsive.Desktop>
			<p>Modern Design &nbsp;|&nbsp; Fast &nbsp;|&nbsp; Tailored to Your Needs</p>
			<small>scroll down to enter</small>
		</Responsive.Desktop>
		<Responsive.Mobile>
			<p>
				<br />
				Modern Design
				<br />
				Fast
				<br />
				Tailored to Your Needs
			</p>
			<small>scroll down to enter</small>
		</Responsive.Mobile>
  	</TagWrapper>
);

export const Contact = (
	<p>
		Whether you have a project in mind or just want to chat about what we do, send us an email at <a href="mailto:projects@vital38.com">projects@vital38.com</a> or call us at <a href="tel:(650) 336-8624">(650) 336-8624</a>
		<br />
		<br />
		Whatever your needs are, we're here to help make sure you end up with the best product possible! We believe that good design, quality code, and a well-developed idea are essential to any product's success, no matter how big or small.
		<br />
		<br />
		We'd love to get to know you, and can't wait to start helping you achieve your dream, whatever that may be.
		<br />
		<br />
		<br />
	</p>
);


// WEBPACK FOOTER //
// ./src/config/content.js